import {
  CreateNotificationSegment,
  CreateNotificationSegmentVariables
} from './__generated__/CreateNotificationSegment'

import { gql } from 'apollo-boost'
import { useMutation } from '@apollo/react-hooks'

const MUTATION = gql`
  mutation CreateNotificationSegment($input: CreateNotificationSegmentInputV2!) {
    createNotificationSegment: createNotificationSegmentV2(input: $input) {
      ... on NotificationSegmentV2 {
        id
        title
        isDynamic
        dynamicUrl
      }
    }
  }
`

export const useCreateNotificationSegment = () =>
  useMutation<CreateNotificationSegment, CreateNotificationSegmentVariables>(MUTATION)
